import { FlexStyled } from './Flex.styled';

export const Flex = FlexStyled;
